import React from "react";
import { CentsField, Form } from "@culturehq/components";
import { ImpressionCost, ImpressionsTabProps } from "./types";
import socialOptions from "./socialOptions";
import displayTooltip from "./displayTooltip";

const ImpressionsTab: React.FC<ImpressionsTabProps> = ({
  socialMediaTypes,
  costs,
  setCost
}) => {
  const handleChange = (
    socialType: string,
    exists: boolean
  ) => (value: any) => {
    const update = (prev: ImpressionCost[]) => prev.map(
      (ic: any) => (
        ic.socialMediaType === socialType
          ? { ...ic, cost: value }
          : ic
      )
    );
    const insert = (prev: Partial<ImpressionCost>[]) => [...prev, {
      socialMediaType: socialType,
      cost: value
    }];

    setCost(prev => (exists ? update(prev) : insert(prev)));
  };

  return (
    <div>
      <h4>Impressions total cost</h4>
      <Form onSubmit={() => {}}>
        {socialOptions.map(op => {
          const cost = costs.find(cs => cs.socialMediaType === op.value);
          const exists = !!cost;
          const disabled = !socialMediaTypes?.find(smt => smt.name === op.label);

          return (
            <div className="emvTooltip">
              {displayTooltip(disabled,
                <CentsField
                  name={op.value}
                  disabled={disabled}
                  onChange={handleChange(op.value, exists)}
                  value={cost?.cost}
                >
                  {op.label}
                </CentsField>
              )}
            </div>
          );
        }
        )}
      </Form>
    </div>
  );
};

export default ImpressionsTab;
